import { getErrorMessage } from "../config/Error_Codes";

function AuthHandler(status, setToast, navigate) {

    if (status === 401) {
        localStorage.clear();
        navigate('/login', { replace: true });
       // window.location.reload();
    } else if (status === 403) {
        console.log("Authentication failed");
        setToast({ message: 'Sorry, Authentication failed.', type: 'failed' });
        
        setTimeout(() => {
            localStorage.clear();
        navigate("/login", { replace: true });
        //window.location.reload();

        }, 3000);
    } else if (status === 409) {
        setToast({ message: getErrorMessage(status), type: 'failed' });
        
    }else {
        setToast({ message: getErrorMessage(status), type: 'failed' });

    }

};

// function clearLogins() {
//     localStorage.removeItem('authToken');
//     localStorage.removeItem('userData');
//     localStorage.removeItem('userRole');
//     localStorage.removeItem('userName');
//     localStorage.removeItem('userId');
//     localStorage.removeItem('userEmail');
//     localStorage.removeItem('userPhone');
//     localStorage.removeItem('userImage');
// }


export default AuthHandler;